import "./AddBulk.css";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import RoutesConstants from "../../../shared-components/Routes/routes.constants";
import AddBulkForm from "./forms/AddBulkForm";
import { useStore } from "../../../contexts/StoreProvider";
import IAddDeviceBulk from "../../../models/Form/IAddDeviceInBulk";
import protocolEnum from "../../../constants/protocol-enum";
import { getTenantIdFromLocalStorage } from "../../../helpers/local-stotrage-helper";
import { formatMessage } from "../../../translations/format-message";

const AddBulk = (props: any) => {
  const { deviceStore, groupStore } = useStore();
  const { GetAllGroupService, allAvailableGroups } = groupStore;
  const { addDeviceInBulk,addBulkDeviceState } = deviceStore;
  const groupList = allAvailableGroups?.map((group:any) => {
    if(group?.protocol === protocolEnum.AWSIoT)
      return {...group, disabled:true};
    else
      return group; 
    });
  const onSubmitForm = (values: IAddDeviceBulk) => {
    addDeviceInBulk(values);
  };

  const initialValue = {
    GroupId: 0,
    Name:"",
    StartICCID:"",
    EndICCID:"",
    api_type:1,
    AddDevices: [{
      Name:"",
      ICCID:0
    }],
  };

  useEffect(() => {
    GetAllGroupService(getTenantIdFromLocalStorage());
  }, []);

  /* Returning JSX */
  return (
    <React.Fragment>
      <div className="icon-nav navbar-fixed-top device-nav-bar deviceTop">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="filter-left-area ps-5">
              <ul className="d-flex align-items-center mt-1">
              <li title={formatMessage("back")}>
                <button role="" className="btn btn-secondary"  onClick={() => props.history.push(RoutesConstants.Device)}>
                    <i className="fa fa-arrow-left"></i>
                </button>
                </li>
                <li className="ms-2">
                  <p className="mb-0 h5">
                    <FormattedMessage id="add_bulk_devices" />
                  </p>
                </li>
              </ul>
            </div>
            <div className="add-list p-0">
              <ul></ul>
            </div>
          </div>
        </div>
      </div>
      <AddBulkForm
        submitHandler={onSubmitForm}
        groupList={groupList}
        isAdding={addBulkDeviceState.inProgress}
        initialValues={initialValue}
      />
    </React.Fragment>
  );
};

export default observer(AddBulk);
